import { ajaxPostJson, ajaxGetJson } from './ajax';
import url from './url'
//分页获取班级管理列表
export const getClassList = (params) => {
  return ajaxPostJson(`/companyUser/queryClass`, params, 'BaseApi');
};
//创建班级
export const saveClass = (params) => {
  return ajaxPostJson(`/companyUser/saveClass`, params, 'BaseApi');
}
//删除班级
export const deleteClass = (params) => {
  return ajaxPostJson(`/companyUser/deleteClass`, params, 'BaseApi');
}
//删除班级学生
export const deleteClassUser = (params) => {
  return ajaxPostJson(`/companyUser/deleteClassUser`, params, 'BaseApi');
}
//获取单个班级信息
export const getClassById = (params) => {
  return ajaxPostJson(`/companyUser/getClassById`, params, 'BaseApi');
}
//编辑班级信息
export const updateClass = (params) => {
  return ajaxPostJson(`/companyUser/updateClass`, params, 'BaseApi');
}
//修改班级学生姓名
export const updateClassUserName = (params) => {
  return ajaxPostJson(`/companyUser/updateClassUserName`, params, 'BaseApi');
}
//分页获取班级里的学生
export const getClassStudentList = (params) => {
  return ajaxPostJson(`/companyUser/queryClassStudentPage`, params, 'BaseApi');
}
//分页获取我的班级
export const getMyClassList = (params) => {
  return ajaxPostJson(`/companyUser/queryMyClass`, params, 'BaseApi');
}
//获取验证码
export const createClassQrCode = (params) => {
  return ajaxPostJson(`/companyUser/createClassQrCode`, params, 'BaseApi');
}
//下载班级报告
export const downloadClassMultipleHomeworkReport = (params) => {
  return ajaxPostJson(`/fileTask/downloadClassMultipleHomeworkReport`, params, 'BaseApi');
}
//批量下载学生报告
export const batchdownloadStudentreport = (params) => {
  return ajaxPostJson(`/fileTask/downloadSinglePersonMultipleHomeworkReport`, params, 'BaseApi');
}
//获取学生信息
export const queryClassUserName = (params) => {
  return ajaxPostJson(`/companyUser/queryClassUserName`, params, 'BaseApi');
}
//获取组织架构人员总数
export const getUserTotalNum = (params) => {
  return ajaxPostJson(`/user/getUserTotalNum`, params, 'BaseApi');
}